// extracted by mini-css-extract-plugin
export default {"container":"desktop-header_container__chNy3","content":"desktop-header_content__XfpSF"};